import getHCStorage from '../storage-manager/getHCStorage';
import storePhoneNumberCampaign from '../storage-manager/storePhoneNumberCampaign';
import getPhoneCallManagement from '../../core/getPhoneCallManagement';


/**
 * @public
 * Gets the phone number and updates the `invoca_phone` in `localStorage`
 *
 * @param  {Object} options - parameters to send:
 *  {
 *    "product": {String} (optional)
 *    "src": {String} (optional)
 *    "publisher_click_id": {String} (optional)
 *    "session_id": {String} (optional)
 *    "user_id": {String} (optional)
 *    "sub_id": {String|Number} (optional)
 *    "experiment_id": {String} (optional)
 *    "variation_id": {String} (optional)
 *    "device": {String} (required)
 *    "placement": {String} (required)
 *    "state": {String} (optional)
 *    "zip": {String} (optional)
 *    "request_url": {String} (optional)
 *    "site": {String} (optional)
 *  }
 * @return {Promise}
 */
export default function getPhoneNumber(options) {
  const hcStorage = getHCStorage();
  const invocaPhone = hcStorage.invoca_phone;
  const lastPlacement = invocaPhone.placement || options.placement;

  if (invocaPhone && invocaPhone.promo_number && invocaPhone.source === hcStorage.source && lastPlacement === options.placement) {
    return Promise.resolve({ phone: invocaPhone });
  }

  return getPhoneCallManagement({ hcStorage, options })
    .then(phoneResponse => storePhoneNumberCampaign(phoneResponse, options));
}
